<template>
    <div>
        <div class="pdfok" id="pdfok" v-if="pdfok"></div>
        <div v-if="dataover222" id="printMe" style=" width: 21cm; margin: 0 auto;">

            <Rules v-if="show_dev"></Rules>
            <!-- <div v-if="show_dev" class="A4Container"></div> -->
            <Rules2 v-if="show_dev"></Rules2>
            <!-- <div v-if="show_dev" class="A4Container"></div> -->
            <Rules3 v-if="show_dev" :stuInfo="stuInfo"></Rules3>

        </div>

        <!--    <el-button v-print="'#printMe'" type="primary" style="position: fixed;top: 60px;right: 10px;z-index: 999;">-->
        <!--      打印-->
        <!--    </el-button>-->

    </div>
</template>

<script>
import Rules from "./com_stu/test";
import Rules2 from "./com_stu/test2";
import Rules3 from "./com_stu/test3";
export default {
    name: 'export',
    components: { Rules, Rules2, Rules3 },
    data() {
        return {
            pdfok: false,
            show_dev: true,
            show_dev1: true,
            dataover222: true,
            showIdentify: false,
            printObj: {
                id: 'printMe',
                popTitle: '',
                extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
            },
            userid: '',

            stuInfo: {},
            yuebao: [{}],
            zhoubao: [{}],
            chinaCitys: [],
            // 填入导出的pdf文件名和html元素
            pdfTitle: '试卷1',
            pdfSelector: '#printMe',
            pmid: '',
        }
    },
    mounted() {
        let id = this.getParams('id')
        let pmid = this.getParams('pmid')
        // let id = 'fd05786013204a96ae7586c9cd77a32a'
        this.pmid = pmid
        console.log(1111111, id, pmid)
        this.getChinaCity().then(rr => {
        })
        this.getDataList(id, pmid)

    },
    methods: {
        //过滤特殊字符, 校验所有输入域是否含有特殊符号
        stripscript(s) {
            var pattern = new RegExp('[&mdash;]')
            var rs = ''
            for (var i = 0; i < s.length; i++) {
                rs = rs + s.substr(i, 1).replace(pattern, '-')
            }
            return rs
        },

        getChinaCity() {
            return new Promise(resolve => {
                this.$http.post("/api/china_citys").then(res => {
                    this.chinaCitys = res.data
                    resolve()
                })
            })
        },
        findDeep(list, iid) {
            for (let i in list) {
                if (list[i].value === iid) {
                    return [list[i]]
                }
                if (list[i].children != null) {
                    let node = this.findDeep(list[i].children, iid);
                    if (node !== undefined) {
                        return node.concat(list[i])
                    }
                }
            }

        },
        getDataList(stuid) {
            let _this = this

            // this.$http.post('http://zsapi.aiwx.org.cn/api/check_area_major_plan',).then(res => {
            this.$http.post('https://zsapi.aiwx.org.cn/api/get_stuinfo_nologin', {
                stuid: stuid
            }).then(res => {
                if (res.data && res.data && res.data.length > 0) {
                    res.data.map(async r => {
                        r.cdate = r.cdate.substring(0, 10)
                        if (r.pjson && this.isJSON(r.pjson)) {
                            r.pjson = JSON.parse(r.pjson);
                            if (r.pjson.handsign) {
                                r.handsign = r.pjson.handsign
                                if (r.handsign.indexOf('OSSAccessKeyId') > -1) {
                                    const parts = r.handsign.split("?");
                                    r.handsign = parts[0];
                                    r.handsign += `?x-oss-process=image/resize,m_fill,h_100,w_200`
                                }
                                // if (r.handsign.indexOf('oss') > -1) {
                                //     r.handsign += `?x-oss-process=image/resize,m_fill,h_150,w_110`
                                // }
                            }
                            if (r.pjson.handsignstu) {
                                r.handsignstu = r.pjson.handsignstu
                                if (r.handsignstu.indexOf('OSSAccessKeyId') > -1) {
                                    const parts = r.handsignstu.split("?");
                                    r.handsignstu = parts[0];
                                    r.handsignstu += `?x-oss-process=image/resize,m_fill,h_100,w_200`
                                }
                                // if (r.handsignstu.indexOf('oss')>-1) {
                                //     r.handsignstu += `?x-oss-process=image/resize,m_fill,h_150,w_110`
                                // }
                            }
                        }
                    })
                    this.stuInfo = {
                        cdate: res.data[0].cdate,
                        handsign: res.data[0].handsign,
                        handsignstu: res.data[0].handsignstu,
                        xuezhi: res.data[0].xuezhi,
                    }
                    console.log(122, this.stuInfo)

                } else {
                    this.stuInfo = {}
                }
                this.$nextTick(() => {
                    setTimeout(() => { _this.pdfok = true }, 500)
                })
            })
        },

        getParams(name) {
            let n_url = window.location.href
            n_url = n_url.replace('/#', '')
            if (n_url.indexOf('?') > 0) {
                n_url = n_url.split('?')[1]
            }
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
            var r = n_url.match(reg)
            if (r != null) return unescape(r[2])
            return null
        },
        //分割数组 arr：原数组  num：分割后每个数组里的数据条数
        util_spliceArrByN(arr, num) {
            var _arr = []
            while (arr.length) {
                _arr.push(arr.splice(0, num))
            }
            return _arr
        },
        //数组按某属性分组
        groupBy(array, f) {
            let groups = {}
            array.forEach(function (o) {
                let group = JSON.stringify(f(o))
                groups[group] = groups[group] || []
                groups[group].push(o)
            })
            return Object.keys(groups).map(function (group) {
                return groups[group]
            })
        }
    }
}
</script>
<style lang="less" type="text/less">
@import "/public/css/pdf_default";
</style>
